module.exports = __webpack_public_path__ + "fonts/CeraPro-Medium.fda916f.woff";